import React from 'react';

import phoneWithQr from '@images/PaymentProcessing/phoneWithQr.png';
import phoneWithCard from '@images/PaymentProcessing/creditCard.png';

const ScanPay: React.FC = () => {
	return <section className="scan-pay payments-processing__item">
		<div className="scan-pay__container payments-processing__container">
			<div className="scan-pay__text-block text-block">
				<h1 className="text-block__title">Scan & Pay</h1>
				<ul className="text-block__list">
					<li>Set Up QR Code for your clinic</li>
					<li>Checkout patient</li>
					<li>Scan clinic QR Code</li>
					<li>Open card not present form</li>
					<li>Complete payment in any convenient way</li>
				</ul>
				<a href="/payments-processing#request-demo" className="text-block__link">request a demo</a>
			</div>
			<div className="scan-pay__image image-block">
				<div className="image-block__img qr-img">
					<img src={phoneWithQr} alt="Phone with QR code" />
				</div>
				<div className="image-block__img phone-img">
					<img src={phoneWithCard} alt="Phone with credit card" />
				</div>
			</div>
		</div>
	</section>;
};

export default ScanPay;
